import translation from 'locales/translation';
/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Grid, Typography } from '@material-ui/core';
import { PautaEvento } from 'api/Assessor/pautas';
import relatorioApi from 'api/Assessor/relatorios';
import ProgressBar from 'components/__ASSESSOR__/progressBar2/ProgressBar';
import { DownloadIcon } from 'components/Icons';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import { AssemblyModalitiesNumber } from 'helpers/enums/Assembleia';
import { AssembleiaTipoPauta } from 'helpers/enums/AssembleiaPautaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { DateFormats } from 'helpers/enums/DateTypes';
import { ParametroTipoResultado } from 'helpers/enums/Parametros';
import { getFormatedDateTime } from 'helpers/utils/DateUtils';
import DownloadTrigger from 'helpers/utils/DownloadTrigger';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { clsx } from 'helpers/utils/HTMLUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { capitalize } from 'helpers/utils/StringUtils';
import {
  Button,
  ButtonThemes,
  ChevronArrowDownIcon,
  Col,
  Collapse,
  Doughnut,
  Row,
  Select,
  useDropOpened,
} from 'plataforma-fundacao-componentes';
import {
  Fragment,
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assembleiaAssessorAcompanhamentoParcial } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IReducer } from 'store/Reducer';
import { sortItensPautaById } from '../../../../helpers/utils/AssembleiaUtils';
import { IModalProps } from '../../../../store/modules/ModalsReducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import { useStyles } from './styles';

import { IPauta } from 'components/__SHARED__/AssembleiaPautas/AssembleiaPautasNews';
import './styles.scss';

export interface IAcompanharVotacaoPautaModalGenericProps
  extends IGenericModalProps {
  key: string;
  pauta: IPauta | PautaEvento;
  idPauta?: any;
}

export interface IAcompanharVotacaoPautaModal extends IModalProps {
  genericProps?: IAcompanharVotacaoPautaModalGenericProps;
}

interface ResultadoParcialType {
  idPauta?: string;
  percentualDeVotos?: number;
  percentualDeVotosDigitais: number;
  percentualDeVotosPresenciais: number;
  quorumAtingido?: boolean;
  tipoResultado?: string;
  titulo?: string;
  totalNaoVotos?: number;
  totalVotos?: number;
  totalVotosDigitais: number;
  totalVotosPresenciais: number;
  totalNucleosQueVotaram?: number;
  totalNucleosQueNaoVotaram?: number;
  totalAssociados?: number;
  totalAssociadosDigitais: number;
  totalAssociadosPresenciais: number;
  totalNucleos?: number;
  itens?: {
    idItemPauta: number;
    descricao: string;
    votos: number;
    percentual: number;
    abstencao: boolean;
  }[];
  itensDigitais?: {
    idItemPauta: number;
    descricao: string;
    votos: number;
    percentual: number;
    abstencao: boolean;
  }[];
  itensPresenciais?: {
    idItemPauta: number;
    descricao: string;
    votos: number;
    percentual: number;
    abstencao: boolean;
  }[];
  consolidado?: {
    totalNucleos?: number | any;
    totalNucleosQuorumAtingido?: number;
    itens: {
      idItemPauta: number;
      descricao: string;
      votos: number;
      percentual: number;
      abstencao: boolean;
    }[];
  };
  agencias: {
    codigoAgencia: string;
    nucleos: {
      numeroNucleo: string;
      totalAssociados: number;
      presentes: number;
      percentualDeVotos: number;
      quorumAtingido: boolean;
      itens: {
        idItemPauta: number;
        descricao: string;
        votos: number;
        percentual: number;
        abstencao: boolean;
      }[];
      resultadoDigital: {
        itens: {
          idItemPauta: number;
          descricao: string;
          votos: number;
          percentual: number;
          abstencao: boolean;
        }[];
        numeroNucleo: string;
        percentualDeVotos: number;
        presentes: number;
        totalAssociados: number;
      };
      resultadoPresencial: {
        itens: {
          idItemPauta: number;
          descricao: string;
          votos: number;
          percentual: number;
          abstencao: boolean;
        }[];
        numeroNucleo: string;
        percentualDeVotos: number;
        presentes: number;
        totalAssociados: number;
      };
    }[];
  }[];
}

interface ConsolidadoProps {
  abstencao: boolean;
  descricao: string;
  idItemPauta: number;
  percentual: number;
  votos: number;
}

export default function AcompanharVotacaoPautaModal({
  genericProps,
  open,
}: IAcompanharVotacaoPautaModal) {
  const classes = useStyles();
  const [resultadoParcial, setResultadoParcial] =
    useState<ResultadoParcialType>();
  const [valueAg, setValueAg] = useState<string[] | string>();
  const [valueNuc, setValueNuc] = useState<string[] | string>();
  const [nucleosOptions, setNucleosOptions] =
    useState<{ value: string; label: string }[]>();
  const [presencialOpen, setPresencialOpen] = useState<boolean>(false);
  const [digitalOpen, setDigitalOpen] = useState<boolean>(false);
  const [opened, setOpened] = useDropOpened<string | undefined>(undefined);

  const dispatch = useDispatch();
  const { evento } = useSelector(
    (state: IReducer) => state.assembleiasAssessor
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const timeoutRef = useRef<any>();

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatch(modalsActionsClose(genericProps.key));
    }
  }, [dispatch, genericProps]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const getResultadoParcial = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setLoading(true);
    setDisabled(true);

    timeoutRef.current = setTimeout(() => {
      setDisabled(false);
    }, 10000);

    dispatch(
      assembleiaAssessorAcompanhamentoParcial(
        genericProps?.idPauta,
        (response: any) => {
          setResultadoParcial(response);
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      )
    );
  }, [dispatch, genericProps]);

  useEffect(() => {
    if (!resultadoParcial) {
      getResultadoParcial();
    }
  }, [getResultadoParcial, resultadoParcial]);

  const resultType = (evento: string) => {
    switch (evento) {
      case translation.ResultadoParcialModal.agenciaNucleo:
        return ParametroTipoResultado.agenciaNucleo;
      case translation.ResultadoParcialModal.agencia:
        return ParametroTipoResultado.agencia;
      case translation.ResultadoParcialModal.evento:
        return ParametroTipoResultado.evento;
      case translation.ResultadoParcialModal.aoe:
        return translation.RespostaPautaAGO.title.AOE;
      case translation.ResultadoParcialModal.ago:
        return translation.RespostaPautaAGO.title.AGO;
      case translation.ResultadoParcialModal.age:
        return translation.RespostaPautaAGO.title.AGE;
      default:
        return translation.ResultadoParcialModal.error;
    }
  };

  useEffect(() => {
    if (valueAg?.length === 1) {
      setNucleosOptions(
        resultadoParcial?.agencias
          .find((ag) => ag.codigoAgencia === valueAg[0])
          ?.nucleos.map((nucleo) => {
            return {
              value: nucleo.numeroNucleo,
              label: nucleo.numeroNucleo,
            };
          })
      );
    } else {
      setNucleosOptions([]);
    }
  }, [resultadoParcial, JSON.stringify(valueAg)]);

  const downloadResultado = useCallback(async () => {
    const { fail, data } = await relatorioApi.downloadResultadoParcialAGOAGEAOE(
      resultadoParcial?.idPauta!
    );
    if (fail) {
      ErrorHandler(fail);
    }
    if (data) {
      const fileDate = getFormatedDateTime(Date.now(), DateFormats.ISOFile);
      DownloadTrigger(
        `Resultado parcial_Evento ${evento!.id}_${fileDate}.xlsx`,
        data
      );
    }
  }, [evento, resultadoParcial]);

  const leftValue = useMemo(() => {
    return resultadoParcial?.tipoResultado
      ? typeof resultadoParcial?.totalVotos === 'number'
        ? resultadoParcial?.totalVotos
        : 0
      : resultadoParcial?.totalNucleosQueVotaram;
  }, [resultadoParcial]);

  const rightValue = useMemo(() => {
    return resultadoParcial?.tipoResultado
      ? typeof resultadoParcial?.totalNaoVotos === 'number'
        ? resultadoParcial?.totalNaoVotos
        : 0
      : resultadoParcial?.totalNucleosQueNaoVotaram;
  }, [resultadoParcial]);

  const leftValuePresencial = useMemo(() => {
    return resultadoParcial?.tipoResultado
      ? typeof resultadoParcial?.totalVotosPresenciais === 'number'
        ? resultadoParcial?.totalVotosPresenciais
        : 0
      : resultadoParcial?.totalNucleosQueVotaram;
  }, [resultadoParcial]);

  const leftValueDigital = useMemo(() => {
    return resultadoParcial?.tipoResultado
      ? typeof resultadoParcial?.totalVotosDigitais === 'number'
        ? resultadoParcial?.totalVotosDigitais
        : 0
      : resultadoParcial?.totalNucleosQueVotaram;
  }, [resultadoParcial]);

  useLayoutEffect(() => {
    if (genericProps?.pauta.codigoAgencia && genericProps?.pauta.numeroNucleo) {
      setValueAg(genericProps?.pauta.codigoAgencia);
      setValueNuc(genericProps?.pauta.numeroNucleo);
    }
  }, [genericProps?.pauta.codigoAgencia]);

  return (
    <GenericModal
      open={open ?? false}
      title={
        resultadoParcial?.tipoResultado
          ? `${translation.ResultadoParcialModal.title} ${
              resultadoParcial?.tipoResultado &&
              '| ' + resultadoParcial?.tipoResultado
            }`
          : resultType(evento!?.tipo!)
      }
      loading={loading}
      showRefreshButton
      onRefresh={getResultadoParcial}
      refreshDisabled={disabled}
      content={
        <div key={getUniqueKey()}>
          {!resultadoParcial ? (
            <Loading inline />
          ) : (
            <>
              <Typography
                className={classes.subtitle}
                component={'h1'}
                style={
                  evento?.modo !== AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                    ? { marginBottom: '20px' }
                    : {}
                }
              >
                {resultadoParcial?.titulo}
              </Typography>
              {genericProps?.pauta.tipoPauta ===
                AssembleiaTipoPauta.Coordenador ||
                (evento?.modo !==
                  AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO && (
                  <Divider style={{ marginBottom: '1rem' }} />
                ))}

              {genericProps?.pauta.tipoPauta !==
                AssembleiaTipoPauta.Coordenador && (
                <>
                  {(evento?.modo ===
                    AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO &&
                    ['AGO', 'AOE', 'AGE', 'AGN', 'REU'].includes(
                      evento?.tipo || ''
                    )) ||
                  (evento?.modo !==
                    AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO &&
                    !['AGO', 'AOE', 'AGE'].includes(evento?.tipo || '')) ? (
                    <Grid
                      className={`${classes.progressBarWrapper} ${
                        resultadoParcial?.tipoResultado ===
                          translation.ResultadoParcialModal.evento && 'event'
                      }`}
                    >
                      {resultadoParcial?.tipoResultado ===
                        translation.ResultadoParcialModal.evento && (
                        <Typography
                          className={classes.quorumTitle}
                          component={'p'}
                        >
                          Quórum Atingido:{' '}
                          {resultadoParcial?.quorumAtingido === true
                            ? translation.ResultadoParcialModal.sim
                            : translation.ResultadoParcialModal.nao}
                        </Typography>
                      )}
                      <ProgressBar
                        leftValue={leftValue || 0}
                        rightValue={
                          resultadoParcial!?.totalAssociados! -
                            resultadoParcial!?.totalVotos! || 0
                        }
                        leftText={
                          translation.ResultadoParcialModal.votaram.true[
                            evento?.tipo === AssembleiaTipo.Nucleo ||
                            evento?.tipo === AssembleiaTipo.Reuniao
                              ? 'associados'
                              : 'nucleos'
                          ][leftValue !== 1 ? 'plural' : 'singular']
                        }
                        rightText={
                          translation.ResultadoParcialModal.votaram.false[
                            evento?.tipo === AssembleiaTipo.Nucleo ||
                            evento?.tipo === AssembleiaTipo.Reuniao
                              ? 'associados'
                              : 'nucleos'
                          ][rightValue !== 1 ? 'plural' : 'singular']
                        }
                        percent={
                          typeof resultadoParcial!?.percentualDeVotos ===
                          'number'
                            ? Math.round(resultadoParcial!?.percentualDeVotos)
                            : 0
                        }
                        title={translation.ResultadoParcialModal.aptos[
                          evento?.tipo === AssembleiaTipo.Nucleo ||
                          evento?.tipo === AssembleiaTipo.Reuniao
                            ? 'associados'
                            : 'nucleos'
                        ](
                          resultadoParcial?.tipoResultado
                            ? resultadoParcial?.totalAssociados
                            : resultadoParcial?.totalNucleos
                        )}
                      />
                    </Grid>
                  ) : undefined}
                  {(evento?.modo ===
                    AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO &&
                    evento?.tipo === AssembleiaTipo.Nucleo) ||
                  (evento?.modo ===
                    AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO &&
                    evento?.tipo === AssembleiaTipo.Reuniao) ? (
                    <Fragment>
                      <Grid
                        className={`${classes.progressBarWrapper} ${
                          resultadoParcial?.tipoResultado ===
                            translation.ResultadoParcialModal.evento && 'event'
                        }`}
                        onClick={() => setPresencialOpen((evt) => !evt)}
                      >
                        <Row
                          className={clsx([
                            classes.collapse,
                            presencialOpen ? 'active' : '',
                          ])}
                        >
                          <Col cols={[6, 6, 6, 6, 6]} noPadding>
                            <Typography>Total Presencial</Typography>{' '}
                          </Col>
                          <Col cols={[6, 6, 6, 6, 6]} noPadding end>
                            <ChevronArrowDownIcon />
                          </Col>
                        </Row>
                        <Collapse opened={presencialOpen}>
                          <ProgressBar
                            leftValue={leftValuePresencial || 0}
                            rightValue={
                              resultadoParcial!?.totalAssociadosPresenciais! -
                                resultadoParcial!?.totalVotosPresenciais! || 0
                            }
                            leftText={
                              translation.ResultadoParcialModal.votaram.true[
                                evento?.tipo === AssembleiaTipo.Nucleo ||
                                evento?.tipo === AssembleiaTipo.Reuniao
                                  ? 'associados'
                                  : 'nucleos'
                              ][
                                leftValuePresencial !== 1
                                  ? 'plural'
                                  : 'singular'
                              ]
                            }
                            rightText={
                              translation.ResultadoParcialModal.votaram.false[
                                evento?.tipo === AssembleiaTipo.Nucleo ||
                                evento?.tipo === AssembleiaTipo.Reuniao
                                  ? 'associados'
                                  : 'nucleos'
                              ][rightValue !== 1 ? 'plural' : 'singular']
                            }
                            percent={
                              typeof resultadoParcial!
                                ?.percentualDeVotosPresenciais === 'number'
                                ? Math.round(
                                    resultadoParcial!
                                      ?.percentualDeVotosPresenciais
                                  )
                                : 0
                            }
                            title={translation.ResultadoParcialModal.aptos[
                              evento?.tipo === AssembleiaTipo.Nucleo ||
                              evento?.tipo === AssembleiaTipo.Reuniao
                                ? 'associados'
                                : 'nucleos'
                            ](
                              resultadoParcial?.tipoResultado
                                ? resultadoParcial?.totalAssociadosPresenciais
                                : resultadoParcial?.totalNucleos
                            )}
                          />
                        </Collapse>
                      </Grid>
                      <Grid
                        className={`${classes.progressBarWrapper} ${
                          resultadoParcial?.tipoResultado ===
                            translation.ResultadoParcialModal.evento && 'event'
                        }`}
                        onClick={() => setDigitalOpen((evt) => !evt)}
                      >
                        <Row
                          className={clsx([
                            classes.collapse,
                            digitalOpen ? 'active' : '',
                          ])}
                        >
                          <Col cols={[6, 6, 6, 6, 6]} noPadding>
                            <Typography>Total Digital</Typography>{' '}
                          </Col>
                          <Col cols={[6, 6, 6, 6, 6]} noPadding end>
                            <ChevronArrowDownIcon />
                          </Col>
                        </Row>
                        <Collapse opened={digitalOpen}>
                          <ProgressBar
                            leftValue={leftValueDigital || 0}
                            rightValue={
                              resultadoParcial!?.totalAssociadosDigitais! -
                                resultadoParcial!?.totalVotosDigitais! || 0
                            }
                            leftText={
                              translation.ResultadoParcialModal.votaram.true[
                                evento?.tipo === AssembleiaTipo.Nucleo ||
                                evento?.tipo === AssembleiaTipo.Reuniao
                                  ? 'associados'
                                  : 'nucleos'
                              ][leftValue !== 1 ? 'plural' : 'singular']
                            }
                            rightText={
                              translation.ResultadoParcialModal.votaram.false[
                                evento?.tipo === AssembleiaTipo.Nucleo ||
                                evento?.tipo === AssembleiaTipo.Reuniao
                                  ? 'associados'
                                  : 'nucleos'
                              ][rightValue !== 1 ? 'plural' : 'singular']
                            }
                            percent={
                              typeof resultadoParcial!
                                ?.percentualDeVotosDigitais === 'number'
                                ? Math.round(
                                    resultadoParcial!?.percentualDeVotosDigitais
                                  )
                                : 0
                            }
                            title={translation.ResultadoParcialModal.aptos[
                              evento?.tipo === AssembleiaTipo.Nucleo ||
                              evento?.tipo === AssembleiaTipo.Reuniao
                                ? 'associados'
                                : 'nucleos'
                            ](
                              resultadoParcial?.tipoResultado
                                ? resultadoParcial?.totalAssociadosDigitais
                                : resultadoParcial?.totalNucleos
                            )}
                          />
                        </Collapse>
                      </Grid>
                    </Fragment>
                  ) : undefined}

                  <Grid className={classes.textWrapper}>
                    {genericProps?.pauta?.flgSecreta === false && (
                      <Typography component={'h1'}>
                        Acompanhamento consolidado:
                      </Typography>
                    )}

                    {genericProps?.pauta?.flgSecreta === true &&
                      resultadoParcial?.tipoResultado !==
                        translation.ResultadoParcialModal.evento && (
                        <Typography component={'h1'}>
                          Acompanhamento consolidado:
                        </Typography>
                      )}

                    {resultadoParcial?.tipoResultado !==
                      translation.ResultadoParcialModal.evento &&
                      resultadoParcial?.tipoResultado && (
                        <>
                          <Typography component={'p'}>
                            {(
                              translation.ResultadoParcialModal
                                .totalParticipantes as any
                            )[resultType(resultadoParcial?.tipoResultado)](
                              resultadoParcial?.consolidado?.totalNucleos
                            )}
                          </Typography>
                          <Typography component={'p'}>
                            {(
                              translation.ResultadoParcialModal
                                .totalQuorumAtingido as any
                            )[resultType(resultadoParcial?.tipoResultado)](
                              resultadoParcial?.consolidado
                                ?.totalNucleosQuorumAtingido
                            )}
                          </Typography>
                        </>
                      )}
                  </Grid>
                  {resultadoParcial?.tipoResultado ? (
                    <Grid className={classes.progressBarGroup}>
                      {resultadoParcial?.consolidado?.itens
                        .sort(sortItensPautaById)
                        .map((x: ConsolidadoProps, index: number) => {
                          const resultTypeAgn = (evento: string) => {
                            switch (evento) {
                              case translation.ResultadoParcialModal
                                .agenciaNucleo:
                                return x.votos === 0 || x.votos > 1
                                  ? translation.ResultadoParcialModal
                                      .nucleosPercentage
                                  : translation.ResultadoParcialModal
                                      .nucleoPercentage;
                              case translation.ResultadoParcialModal.agencia:
                                return x.votos === 0 || x.votos > 1
                                  ? translation.ResultadoParcialModal
                                      .agenciasPercentage
                                  : translation.ResultadoParcialModal
                                      .agenciaPercentage;
                              case translation.ResultadoParcialModal.evento:
                                return x.votos === 0 || x.votos > 1
                                  ? translation.ResultadoParcialModal
                                      .votosPercentage
                                  : translation.ResultadoParcialModal
                                      .votoPercentage;
                              default:
                                return translation.ResultadoParcialModal.error;
                            }
                          };

                          return (
                            <ProgressBar
                              key={index}
                              leftValue={x.votos}
                              rightValue={x.votos}
                              percent={Math.round(x.percentual)}
                              title={capitalize(x.descricao)}
                              textPercent={`${x.votos} ${resultTypeAgn(
                                resultadoParcial?.tipoResultado!
                              )}`}
                              hideDescription
                            />
                          );
                        })}
                    </Grid>
                  ) : (
                    <>
                      <Grid className={classes.progressBarGroup}>
                        {resultadoParcial!
                          ?.itens!?.sort(sortItensPautaById)!
                          ?.map((x: ConsolidadoProps, index: number) => {
                            return (
                              <ProgressBar
                                key={index}
                                leftValue={x.votos}
                                rightValue={x.votos}
                                percent={Math.round(x.percentual)}
                                title={capitalize(x.descricao)}
                                textPercent={`${
                                  x.votos === 0 || x.votos > 1
                                    ? x.votos +
                                      translation.ResultadoParcialModal
                                        .nucleosPercentage
                                    : x.votos +
                                      translation.ResultadoParcialModal
                                        .nucleoPercentage
                                }  `}
                                hideDescription
                              />
                            );
                          })}
                      </Grid>
                      {evento?.modo ===
                      AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO ? (
                        <Fragment>
                          <Grid
                            className={`${classes.progressBarWrapper} ${
                              resultadoParcial?.tipoResultado ===
                                translation.ResultadoParcialModal.evento &&
                              'event'
                            }`}
                          >
                            <Row
                              className={clsx([
                                classes.collapse,
                                presencialOpen ? 'active' : '',
                              ])}
                              onClick={() => {
                                return setPresencialOpen((evt) => !evt);
                              }}
                            >
                              <Col cols={[6, 6, 6, 6, 6]} noPadding>
                                <Typography>Consolidação Presencial</Typography>{' '}
                              </Col>
                              <Col cols={[6, 6, 6, 6, 6]} noPadding end>
                                <ChevronArrowDownIcon />
                              </Col>
                            </Row>
                            <Collapse opened={presencialOpen}>
                              <div className={classes.doughnutTextWrapper}>
                                <Grid className={classes.progressBarGroup}>
                                  {resultadoParcial.itensPresenciais?.map(
                                    (x: ConsolidadoProps, index: number) => {
                                      return (
                                        <ProgressBar
                                          key={index}
                                          leftValue={x.votos}
                                          rightValue={x.votos}
                                          percent={Math.round(x.percentual)}
                                          title={capitalize(x.descricao)}
                                          hideDescription
                                        />
                                      );
                                    }
                                  )}
                                </Grid>
                              </div>
                            </Collapse>
                          </Grid>
                          <Grid
                            className={`${classes.progressBarWrapper} ${
                              resultadoParcial?.tipoResultado ===
                                translation.ResultadoParcialModal.evento &&
                              'event'
                            }`}
                          >
                            <Row
                              className={clsx([
                                classes.collapse,
                                digitalOpen ? 'active' : '',
                              ])}
                              onClick={() => {
                                return setDigitalOpen((evt) => !evt);
                              }}
                            >
                              <Col cols={[6, 6, 6, 6, 6]} noPadding>
                                <Typography>Consolidação Digital</Typography>{' '}
                              </Col>
                              <Col cols={[6, 6, 6, 6, 6]} noPadding end>
                                <ChevronArrowDownIcon />
                              </Col>
                            </Row>
                            <Collapse opened={digitalOpen}>
                              <div className={classes.doughnutTextWrapper}>
                                <Grid className={classes.progressBarGroup}>
                                  {resultadoParcial.itensDigitais?.map(
                                    (x: ConsolidadoProps, index: number) => {
                                      return (
                                        <ProgressBar
                                          key={index}
                                          leftValue={x.votos}
                                          rightValue={x.votos}
                                          percent={Math.round(x.percentual)}
                                          title={capitalize(x.descricao)}
                                          hideDescription
                                        />
                                      );
                                    }
                                  )}
                                </Grid>
                              </div>
                            </Collapse>
                          </Grid>
                        </Fragment>
                      ) : undefined}
                      <div className={classes.footerBtn}>
                        <Button
                          theme={ButtonThemes.Secondary}
                          leftIcon={<DownloadIcon />}
                          onClick={() => downloadResultado()}
                        >
                          {
                            translation.ResultadoParcialModal
                              .labelBaixarRelatorios
                          }
                        </Button>
                      </div>
                    </>
                  )}
                </>
              )}

              {resultadoParcial?.tipoResultado && (
                <>
                  {genericProps?.pauta.tipoPauta !==
                    AssembleiaTipoPauta.Coordenador && (
                    <>
                      <Divider />
                      <Grid className={classes.textWrapperFilter}>
                        <Typography component={'h1'}>
                          {translation.ResultadoParcialModal.associados.title}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  <Grid spacing={3}>
                    {genericProps?.pauta.tipoPauta !==
                      AssembleiaTipoPauta.Coordenador && (
                      <Grid container spacing={3}>
                        <Grid item xs>
                          <Select
                            label={'Agência'}
                            placeholder={
                              translation.ResultadoParcialModal.associados
                                .agenciaPlaceholder
                            }
                            options={resultadoParcial?.agencias.map(
                              (ag: { codigoAgencia: string }) => {
                                return {
                                  label: ag.codigoAgencia,
                                  value: ag.codigoAgencia,
                                };
                              }
                            )}
                            multiple
                            onChange={(evt) => {
                              setValueAg(evt);
                              setValueNuc(undefined);
                            }}
                            value={valueAg}
                          />
                        </Grid>
                        <Grid item>
                          <Select
                            label={'Núcleo'}
                            placeholder={
                              translation.ResultadoParcialModal.associados
                                .nucleoPlaceholder
                            }
                            disabled={
                              !valueAg || !valueAg.length || valueAg.length > 1
                            }
                            options={nucleosOptions}
                            onChange={(evt) => setValueNuc(evt)}
                            value={valueNuc}
                          />
                        </Grid>
                      </Grid>
                    )}
                    {resultadoParcial?.agencias
                      ?.filter(
                        (agencia) =>
                          !valueAg?.length ||
                          valueAg.indexOf(agencia.codigoAgencia) > -1
                      )
                      .map((agencia) => {
                        return (
                          agencia.nucleos
                            ?.filter(
                              (nucleo) =>
                                !valueNuc?.length ||
                                valueNuc.indexOf(nucleo.numeroNucleo) > -1
                            )
                            // .map((x) => x.resultadoPresencial)
                            .map((nucleo, index) => {
                              return (
                                <div className={classes.containerFilter}>
                                  <div className={classes.doughnutTextWrapper}>
                                    <Doughnut
                                      value={nucleo!?.percentualDeVotos!}
                                      red={!nucleo.quorumAtingido}
                                    />
                                    <div className={classes.textGrid}>
                                      <div className={classes.agnNucWrapper}>
                                        <span>
                                          {translation.ResultadoParcialModal.associados.agencia(
                                            agencia.codigoAgencia
                                          )}
                                        </span>
                                        <span>
                                          {translation.ResultadoParcialModal.associados.nucleo(
                                            nucleo.numeroNucleo
                                          )}
                                        </span>
                                        {resultadoParcial?.tipoResultado !==
                                          'Evento' && (
                                          <span>
                                            {translation.ResultadoParcialModal.associados.quorumAtingido(
                                              nucleo.quorumAtingido
                                                ? translation
                                                    .ResultadoParcialModal.sim
                                                : translation
                                                    .ResultadoParcialModal.nao
                                            )}
                                          </span>
                                        )}
                                      </div>
                                      <div className={classes.associadoWrapper}>
                                        <span>
                                          {translation.ResultadoParcialModal.associados.totalAssociadosAptos(
                                            nucleo?.totalAssociados
                                          )}
                                        </span>
                                        <span>
                                          {translation.ResultadoParcialModal.associados.totalVotos(
                                            nucleo?.presentes
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  {genericProps?.pauta?.flgSecreta ===
                                    false && (
                                    <Grid className={classes.progressBarGroup}>
                                      {nucleo.itens
                                        ?.sort(sortItensPautaById)
                                        ?.map(
                                          (
                                            x: ConsolidadoProps,
                                            index: number
                                          ) => {
                                            return (
                                              <ProgressBar
                                                key={index}
                                                leftValue={x.votos}
                                                rightValue={x.votos}
                                                percent={Math.round(
                                                  x.percentual
                                                )}
                                                title={capitalize(x.descricao)}
                                                hideDescription
                                              />
                                            );
                                          }
                                        )}
                                    </Grid>
                                  )}
                                  {evento?.modo ===
                                  AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO ? (
                                    <Fragment>
                                      <Grid
                                        className={`${
                                          classes.progressBarWrapper
                                        } ${
                                          resultadoParcial?.tipoResultado ===
                                            translation.ResultadoParcialModal
                                              .evento && 'event'
                                        }`}
                                      >
                                        <Row
                                          className={clsx([
                                            classes.collapse,
                                            String(opened) ===
                                            String(
                                              `${index}-${nucleo.numeroNucleo}`
                                            )
                                              ? 'active'
                                              : '',
                                          ])}
                                          onClick={(val: any) => {
                                            setOpened(
                                              `${index}-${nucleo.numeroNucleo}`,
                                              val
                                            );

                                            if (
                                              String(opened) ===
                                              String(
                                                `${index}-${nucleo.numeroNucleo}`
                                              )
                                            ) {
                                              setOpened(
                                                `${index}-${nucleo.numeroNucleo}`,
                                                false
                                              );
                                            }
                                          }}
                                        >
                                          <Col cols={[6, 6, 6, 6, 6]} noPadding>
                                            <Typography>
                                              Consolidação Presencial
                                            </Typography>{' '}
                                          </Col>
                                          <Col
                                            cols={[6, 6, 6, 6, 6]}
                                            noPadding
                                            end
                                          >
                                            <ChevronArrowDownIcon />
                                          </Col>
                                        </Row>
                                        <Collapse
                                          opened={
                                            String(opened) ===
                                            String(
                                              `${index}-${nucleo.numeroNucleo}`
                                            )
                                          }
                                        >
                                          <div
                                            className={
                                              classes.doughnutTextWrapper
                                            }
                                          >
                                            <Doughnut
                                              value={
                                                nucleo!?.resultadoPresencial!
                                                  ?.percentualDeVotos!
                                              }
                                              red={!nucleo.quorumAtingido}
                                            />
                                            <div className={classes.textGrid}>
                                              <div
                                                className={
                                                  classes.agnNucWrapper
                                                }
                                              >
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.agencia(
                                                    agencia.codigoAgencia
                                                  )}
                                                </span>
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.nucleo(
                                                    nucleo.numeroNucleo
                                                  )}
                                                </span>
                                              </div>
                                              <div
                                                className={
                                                  classes.associadoWrapper
                                                }
                                              >
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.totalAssociadosAptos(
                                                    nucleo?.resultadoPresencial
                                                      ?.totalAssociados
                                                  )}
                                                </span>
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.totalVotos(
                                                    nucleo?.resultadoPresencial
                                                      ?.presentes
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          {evento?.modo ===
                                          AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                                            ? genericProps?.pauta
                                                ?.flgSecreta === false && (
                                                <Grid
                                                  className={
                                                    classes.progressBarGroup
                                                  }
                                                >
                                                  {nucleo.resultadoPresencial.itens
                                                    ?.sort(sortItensPautaById)
                                                    ?.map(
                                                      (
                                                        x: ConsolidadoProps,
                                                        index: number
                                                      ) => {
                                                        return (
                                                          <ProgressBar
                                                            key={index}
                                                            leftValue={x.votos}
                                                            rightValue={x.votos}
                                                            percent={Math.round(
                                                              x.percentual
                                                            )}
                                                            title={capitalize(
                                                              x.descricao
                                                            )}
                                                            hideDescription
                                                          />
                                                        );
                                                      }
                                                    )}
                                                </Grid>
                                              )
                                            : undefined}
                                        </Collapse>
                                      </Grid>
                                      <Grid
                                        className={`${
                                          classes.progressBarWrapper
                                        } ${
                                          resultadoParcial?.tipoResultado ===
                                            translation.ResultadoParcialModal
                                              .evento && 'event'
                                        }`}
                                      >
                                        <Row
                                          className={clsx([
                                            classes.collapse,
                                            String(opened) ===
                                            String(
                                              `${nucleo.numeroNucleo}-${index}`
                                            )
                                              ? 'active'
                                              : '',
                                          ])}
                                          onClick={(val: any) => {
                                            setOpened(
                                              `${nucleo.numeroNucleo}-${index}`,
                                              val
                                            );

                                            if (
                                              String(opened) ===
                                              String(
                                                `${nucleo.numeroNucleo}-${index}`
                                              )
                                            ) {
                                              setOpened(
                                                `${nucleo.numeroNucleo}-${index}`,
                                                false
                                              );
                                            }
                                          }}
                                        >
                                          <Col cols={[6, 6, 6, 6, 6]} noPadding>
                                            <Typography>
                                              Consolidação Digital
                                            </Typography>{' '}
                                          </Col>
                                          <Col
                                            cols={[6, 6, 6, 6, 6]}
                                            noPadding
                                            end
                                          >
                                            <ChevronArrowDownIcon />
                                          </Col>
                                        </Row>
                                        <Collapse
                                          opened={
                                            String(opened) ===
                                            String(
                                              `${nucleo.numeroNucleo}-${index}`
                                            )
                                          }
                                        >
                                          <div
                                            className={
                                              classes.doughnutTextWrapper
                                            }
                                          >
                                            <Doughnut
                                              value={nucleo.percentualDeVotos}
                                              red={!nucleo.quorumAtingido}
                                            />
                                            <div className={classes.textGrid}>
                                              <div
                                                className={
                                                  classes.agnNucWrapper
                                                }
                                              >
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.agencia(
                                                    agencia.codigoAgencia
                                                  )}
                                                </span>
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.nucleo(
                                                    evento?.modo ===
                                                      AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                                                      ? nucleo.resultadoDigital
                                                          .numeroNucleo
                                                      : nucleo.numeroNucleo
                                                  )}
                                                </span>
                                              </div>
                                              <div
                                                className={
                                                  classes.associadoWrapper
                                                }
                                              >
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.totalAssociadosAptos(
                                                    evento?.modo ===
                                                      AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                                                      ? nucleo?.resultadoDigital
                                                          .totalAssociados
                                                      : nucleo?.totalAssociados
                                                  )}
                                                </span>
                                                <span>
                                                  {translation.ResultadoParcialModal.associados.totalVotos(
                                                    evento?.modo ===
                                                      AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                                                      ? nucleo?.resultadoDigital
                                                          .presentes
                                                      : nucleo?.presentes
                                                  )}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          {evento?.modo ===
                                          AssemblyModalitiesNumber.HIBRIDO_SIMULTANEO
                                            ? genericProps?.pauta
                                                ?.flgSecreta === false && (
                                                <Grid
                                                  className={
                                                    classes.progressBarGroup
                                                  }
                                                >
                                                  {nucleo.resultadoDigital.itens
                                                    ?.sort(sortItensPautaById)
                                                    ?.map(
                                                      (
                                                        x: ConsolidadoProps,
                                                        index: number
                                                      ) => {
                                                        return (
                                                          <ProgressBar
                                                            key={index}
                                                            leftValue={x.votos}
                                                            rightValue={x.votos}
                                                            percent={Math.round(
                                                              x.percentual
                                                            )}
                                                            title={capitalize(
                                                              x.descricao
                                                            )}
                                                            hideDescription
                                                          />
                                                        );
                                                      }
                                                    )}
                                                </Grid>
                                              )
                                            : undefined}
                                        </Collapse>
                                      </Grid>
                                    </Fragment>
                                  ) : undefined}
                                </div>
                              );
                            })
                        );
                      })}
                  </Grid>
                </>
              )}
            </>
          )}
        </div>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
}
